module.exports = __webpack_public_path__ + "static/media/1.8fb7e57c.png";